import React, { useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { getChartTypes } from "./chartTypes";
import { useChartsStore } from "../../store/chartStore";
import RenkoSettingsModal from "../Modals/RenkoSettingsModal";
import PointAndFigureSettingsModal from "../Modals/PointAndFigureSettingsModal";
import useNavbarDropdown from "./useNavbarDropdown";

const ChartTypeDropdown = () => {
  const selectedChartType = useChartsStore(
    (state) => state.getSelectedChart()?.chartType || "candle",
  );
  const chartId = useChartsStore(
    (state) => state.getSelectedChart()?.id || null,
  );
  const updateChartConfig = useChartsStore((state) => state.updateChartConfig);
  const { dropdownRef, onShow, onHide } = useNavbarDropdown();
  const [showRenkoSettings, setShowRenkoSettings] = useState(false);
  const [showPointFigureSettings, setShowPointFigureSettings] = useState(false);

  const chartValueTemplate = (option) => (
    <div className="navbar-item-content">
      <i className={`chart-icon-${option?.value} navbar-item-icon`}></i>
      <span className="navbar-item-label chart-type-label">Chart</span>
    </div>
  );

  // Render label with highlighted beta tag if present
  const renderLabel = (label) => {
    if (label.includes("(beta)")) {
      const [mainLabel] = label.split(" (beta)");
      return (
        <>
          {mainLabel}
          <span className="beta-tag">(beta)</span>
        </>
      );
    }
    return label;
  };

  const chartItemTemplate = (option) => (
    <div
      className="dropdown-item"
      style={{
        display: "flex",
        alignItems: "center",
        gap: "2px",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
        <i className={`chart-icon-${option.value}`}></i>
        {renderLabel(option.label)}
      </div>
      {option.value === "renko" && (
        <i
          className="pi pi-cog"
          style={{ fontSize: "14px", cursor: "pointer", marginLeft: "8px" }}
          onClick={(e) => {
            e.stopPropagation();
            setShowRenkoSettings(true);
            if (dropdownRef.current) {
              dropdownRef.current.hide();
            }
          }}
          data-evo-id="charttype-btn-renko-settings"
        />
      )}
      {option.value === "pointfigure" && (
        <i
          className="pi pi-cog"
          style={{ fontSize: "14px", cursor: "pointer", marginLeft: "8px" }}
          onClick={(e) => {
            e.stopPropagation();
            setShowPointFigureSettings(true);
            if (dropdownRef.current) {
              dropdownRef.current.hide();
            }
          }}
          data-evo-id="charttype-btn-pointfigure-settings"
        />
      )}
    </div>
  );

  const onChange = (e) => {
    updateChartConfig(chartId, { chartType: e.value });

    // Close the dropdown programmatically
    if (dropdownRef.current) {
      dropdownRef.current.hide();
    }
  };

  return (
    <>
      <Dropdown
        ref={dropdownRef}
        value={selectedChartType}
        options={getChartTypes()}
        onChange={onChange}
        onShow={onShow}
        onHide={onHide}
        placeholder="Chart"
        className="time-dropdown no-scroll-dropdown navbar-button"
        appendTo={document.body}
        style={{
          width: "115px",
          textAlign: "left",
          display: "flex",
          alignItems: "center",
          border: "none",
          borderRadius: "0px",
        }}
        valueTemplate={chartValueTemplate}
        itemTemplate={chartItemTemplate}
        data-evo-id="navbar-chart-type-dropdown"
      />
      <RenkoSettingsModal
        visible={showRenkoSettings}
        onHide={() => setShowRenkoSettings(false)}
        chartId={chartId}
      />
      <PointAndFigureSettingsModal
        visible={showPointFigureSettings}
        onHide={() => setShowPointFigureSettings(false)}
        chartId={chartId}
      />
    </>
  );
};

export default ChartTypeDropdown;
